/**
 * Copyright Mántum All Rights Reserved.
 */
export const KEY_ITEM = 'items';
export const KEY_GROUP = 'groups';
